import { LucideIcon } from "lucide-react";
import styled from "styled-components";

import InfoTip from "../InfoTip";
import Skeleton from "../Skeleton";
import { Grid, Card, Head, Label, Value, IconWrap } from "../KpiStrip/styles";

const Hint = styled.span`
  font-family: 'Aileron', 'Poppins', sans-serif;
  font-size: 12px;
  color: #8a7f74;
  line-height: 1.4;
`;

export interface Stat {
  label: string;
  value: string;
  icon?: LucideIcon;
  hint?: string;
  info?: string;
}

interface StatRowProps {
  stats: Stat[];
  loading?: boolean;
  skeletonCount?: number;
}

const StatRow = ({ stats, loading, skeletonCount }: StatRowProps) => {
  if (loading) {
    const count = skeletonCount ?? stats.length;
    return (
      <Grid $count={count}>
        {Array.from({ length: count }).map((_, i) => (
          <Card key={i}>
            <Skeleton $w="60%" $h="12px" />
            <Skeleton $w="45%" $h="26px" $radius="8px" />
          </Card>
        ))}
      </Grid>
    );
  }

  return (
    <Grid $count={stats.length}>
      {stats.map((s) => {
        const Icon = s.icon;
        return (
          <Card key={s.label}>
            <Head>
              {Icon && (
                <IconWrap>
                  <Icon size={16} />
                </IconWrap>
              )}
              <Label>{s.label}</Label>
              {s.info && <InfoTip text={s.info} label={`About ${s.label}`} />}
            </Head>
            <Value>{s.value}</Value>
            {s.hint && <Hint>{s.hint}</Hint>}
          </Card>
        );
      })}
    </Grid>
  );
};

export default StatRow;
